import AppController from "./app_controller"
import Handlebars from "handlebars"
import _ from "lodash"
import { TabulatorFull as Tabulator } from "tabulator-tables"
import dayjs from "dayjs"
import duration from "dayjs/plugin/duration"
import utc from "dayjs/plugin/utc"
import KeyScanner from "../lib/key_scanner"
import TomSelect from "tom-select"
import ScanQueue from "../lib/scan_queue"
import List from "list.js"
import { Turbo } from "@hotwired/turbo-rails"
dayjs.extend(duration)
dayjs.extend(utc)
import { BrowserMultiFormatReader } from "@zxing/browser"
import { DecodeHintType, BarcodeFormat } from '@zxing/library'


export {
    Handlebars,
    AppController,
    _,
    dayjs,
    Tabulator,
    KeyScanner,
    TomSelect,
    ScanQueue,
    List,
    Turbo,
    BrowserMultiFormatReader,
    DecodeHintType,
    BarcodeFormat
}